<template>
    <div class="header-container">
        <el-row style="height: 100%;">
            <el-col :span="12" class="header-left">
                <img style="width: 60px;height: 60px;" :src="logo" />
                <span class="system-name">高清地图拼接系统</span>
                <span @click="changeLatlngFormat" class="center-coord" v-html="cc"
                    style="line-height: 60px;height: 60px;"></span>
            </el-col>
            <el-col :span="12" class="header-right">
                <span class="menu" @click="showWXQRDailog = true">意见反馈</span>
                <span class="menu" @click="showInstruction = !showInstruction">使用说明</span>
                <span class="menu" style="color: red;" @click="showBuyDialog = true">购买激活码</span>
                <el-dropdown trigger="click">
                    <div class="user-manager">
                        <div class="user-name" v-if="getUser">{{ getUser.userName }}&emsp;<el-tag>{{ getUserType
                                }}</el-tag></div>
                        <div class="user-name" v-else>请先登陆</div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            @click.native="showUserInfoDialog = !showUserInfoDialog">用户信息</el-dropdown-item>
                        <el-dropdown-item
                            @click.native="showChangePasswordDailog = !showChangePasswordDailog">修改密码</el-dropdown-item>

                        <el-dropdown-item @click.native="startActive()">激活账号</el-dropdown-item>
                        <el-dropdown-item divided @click.native="logout">退出登陆</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
        </el-row>

        <el-dialog :visible.sync="showUserInfoDialog" title="用户信息" width="600px" class="mydialog">
            <el-row>
                <el-col :span="8">
                    <div class="title">用户名:</div>
                </el-col>
                <el-col :span="16">
                    <span>{{ getUser.userName }}</span>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="8">
                    <div class="title">注册时间:</div>
                </el-col>
                <el-col :span="16">
                    <span>{{ formatTimestamp(getUser.createTime) }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <div class="title">上次登陆时间:</div>
                </el-col>
                <el-col :span="16">
                    <span>{{ formatTimestamp(getUser.lastIn) }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <div class="title">会员类型:</div>
                </el-col>
                <el-col :span="16">
                    <span v-html="getUserType"></span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <div class="title">会员过期时间:</div>
                </el-col>
                <el-col :span="16">
                    <span>{{ getUser.expiration == 0 ? '-' : formatTimestamp(getUser.expiration) }}</span>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showUserInfoDialog = false">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="showActiveDialog" title="请输入激活码" width="600px" class="mydialog">
            <el-input v-model="activationCode" placeholder="请输入激活码"></el-input>
            <div style="text-align: left;  margin-top: 10px;  font-size: 12px;">
                <span v-if="activationCode === ''" style="color: red;">*激活码不能为空</span>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="saveActivationCode" :loading="activeLoading">激活账号</el-button>
            </span>
        </el-dialog>

        <el-dialog title="扫描下方微信联系客服" :visible.sync="showWXQRDailog" width="400px" class="mydialog">
            <div style="text-align: center;">
                <img :src="wechat" style="width: 120px;height: 120px;" />
            </div>
        </el-dialog>

        <el-dialog title="扫描下方微信联系客服" :visible.sync="showBuyDialog" width="400px" class="mydialog">
            <div style="text-align: center;">
                <p>月卡30,永久99，购买请添加客服微信</p>
                <img :src="wechat" style="width: 120px;height: 120px;" />
            </div>
        </el-dialog>


        <el-dialog title="使用说明" :visible.sync="showInstruction" width="600px" class="mydialog">
            <div style="text-align: left;max-height: 700px;overflow-y: auto;">
                <h2>✅制作地图</h2>
                <ul>
                    <li>
                        <h3>step1 点击右侧工具栏的拼接按钮，然后点击地图选择要拼接的区域</h3>
                        <p>
                            <img :src="picStep1" class="instruction-img">
                        </p>
                    </li>
                    <li>
                        <h3>step2 在弹出的菜单中进行相关参数的配置，注意系统最大支持1000块地图的拼接</h3>
                        <p>
                            <img :src="picStep2" class="instruction-img">
                        </p>
                    </li>
                    <li>
                        <h3>step3 通过任务列表掌握任务完成情况，在任务完成后，您可以点击“下载”直接下载拼接好的原图，也可点击“叠加网格”进行网络叠加操作</h3>
                        <p>
                            <img :src="picStep3" class="instruction-img">
                        </p>
                    </li>
                    <li>
                        <h3>step4 调节网格样式，最后点击保存图片可完成最终成品的下载</h3>
                        <p>
                            <img :src="picStep4" class="instruction-img">
                        </p>
                    </li>
                </ul>
                <h2>✅注意事项</h2>
                <p>1.软件不支持webp瓦片文件的格式地图源</p>
                <p>2.每日凌晨2点系统会进行询查删除所有生成的拼接图片，请及时下载完成的任务</p>
                <p>3.系统只支持不大于1000块瓦片的拼接，如果大于1000块建议分片拼接</p>
                <p>4.非vip用户只能下载不大于100块的地图，并且带有水印</p>
                <p>5.系统暂无法叠加中文标注层</p>
                <h2>✅账号收费标准</h2>
                <p>🚀 1.30元每月</p>
                <p>🚀 2.99元永久</p>
            </div>
        </el-dialog>
        <change-password-dialog :show.sync="showChangePasswordDailog"></change-password-dialog>
    </div>
</template>

<script>
import formatter from '@/util/geoUtil';
import util from '@/util/commonUtil.js'
import ChangePasswordDialog from './ChangePassword.vue'
import { active } from '@/util/request';

export default {
    components: {
        'change-password-dialog': ChangePasswordDialog
    },
    name: 'Header',
    props: ["cc"],
    data() {
        return {
            showBuyDialog:false,
            showWXQRDailog: false,
            showActiveDialog: false,
            showUserInfoDialog: false,
            showSuccessDialog: false,
            activationCode: '',
            showInstruction: false,
            activeLoading: false,
            picStep1: require('@/assets/step1.png'),
            picStep2: require('@/assets/step2.png'),
            picStep3: require('@/assets/step3.png'),
            picStep4: require('@/assets/step4.png'),
            wechat: require('@/assets/wechat.jpeg'),
            logo: require('@/assets/txz-logo.png')
        }
    },
    computed: {
        getUser() {
            return this.$store.state.user
        },
        getUserType() {
            if (!this.getUser) {
                return ''
            }
            switch (this.getUser.type) {
                case 1:
                    return `月卡vip`
                case 2:
                    return `永久vip`
                case 0:
                default:
                    return `普通用户`
            }
        }
    },
    methods: {
        openLink() {
            this.$confirm('系统即将跳转到探险者地图官方商城，支付途径为官方途径，请放心购买', '提示', {
                confirmButtonText: '确定',
                type: 'info'
            })
                .then(() => {
                    // 点击确定后打开链接
                    window.open('http://hxy2020.com', '_blank');
                })

        },
        startActive() {

            if (this.$store.getters.vipIsAvailable) {
                this.$message.info('您已经是vip用户')
                return
            }
            this.showActiveDialog = !this.showActiveDialog
        },
        formatTimestamp(timestamp) {
            return util.formatTimestamp(timestamp)
        },
        logout() {
            this.$store.commit('clearUser')
            this.$router.push('/login')
        },
        saveActivationCode() {

            if (this.activationCode.trim() == '') {
                return
            }
            this.activeLoading = true
            active(this.activationCode).then(res => {
                this.activeLoading = false
                if (res.resultCode == -1) {
                    this.$message.error(res.info)
                }
                if (res.resultCode == 1) {
                    this.showActiveDialog = false
                    this.$confirm('激活成功,即将跳转到重新登陆页面', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                    })
                        .then(() => {
                            // 用户点击了确定
                            this.logout()
                        })
                        .catch(() => {
                            // 用户点击了取消

                        });

                }
            })
        },
        changeLatlngFormat: function () {
            formatter.changeLatlngFormat()
            this.$message.success('坐标格式已切换')
        }
    },
    mounted: function () {

    }
}
</script>
<style scoped>
.instruction-img {
    max-width: 400px;
    display: block;
    margin: 0 auto;
    padding: 10px 0;
}

.header-container {
    background-color: white;
    width: 100%;
    padding: 0 20px;
    border: 1px solid white;
    border-top: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .25);
}

.header-right {
    text-align: right;
    height: 60px;
    line-height: 60px;
}

.header-left {
    text-align: left;
    height: 60px;
    line-height: 60px;
    display: flex;
    align-items: center;
}

.system-name {
    padding: 0px 20px;
    font-size: 1.6em;
    color: black;
}

.title {
    text-align: right;
    color: black;

}

.menu {
    cursor: pointer;
    padding: 0px 10px;
}

.center-coord {
    margin-left: 10px;
    line-height: 60px;
    color: black;
    font-size: 16px;
    cursor: pointer;
}

.user-manager {
    padding: 0px 10px;
    margin-left: 10px;
    cursor: pointer;
}

.el-dropdown {
    height: 100%;
}

.user-name {
    height: 30px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Header.vue